import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { makeStyles } from "@material-ui/core/styles";
import { useHistory, useParams } from "react-router-dom";
import { Typography, Box, Card, CardContent } from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import clsx from "clsx";
import Navbar from "components/Navbar";
import DarkLayout from "components/Shared/DarkLayout";
import { PATHS } from "util/appConstants";
import { translatePermission } from "util/helpers";
import { getRoleById, selectRole, selectRolesStatus } from "redux/slices/rolesSlice";
import CheckIcon from "@material-ui/icons/Check";

const useStyles = makeStyles({
  _heading: {
    color: "#F5F5F5",
    font: "normal normal normal 28px/40px Questrial",
  },
  _edit: {
    color: "#6F9CEB",
    width: "22px",
    height: "22px",
    cursor: "pointer",
    transition: "all 0.3s ease-in-out",
    "&:hover": {
      transform: "scale(1.3)",
    },
    "&:hover + span": {
      display: "block",
    },
  },
  _editbox: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  _infoheading: {
    color: "#F5F5F5",
    font: "normal normal medium 22px/32px Roboto",
    marginTop: "44px",
  },
  _head: {
    color: "#F5F5F5",
    opacity: "0.6",
    font: "normal normal normal 12px/24px Roboto",
    marginRight: "32px",
  },
  _basicdetailhead: {
    display: "flex",
    marginTop: "41px",
  },
  _basicdetail: {
    display: "flex",
  },
  _detail: {
    color: "#F5F5F5",
    marginRight: "32px",
    font: "normal normal normal 18px/24px Roboto",
  },
  _name: {
    letterSpacing: "0px",
  },
  _margintop80: {
    marginTop: "80px",
  },
  _adressbox: {
    marginTop: "24px",
  },
  _buttonbox: {
    display: "flex",
    margin: "0 16px",
  },
  _edittext: {
    width: "24px",
    height: "16px",
    color: "#6F9CEB",
    font: "normal normal normal 14px / 20px Roboto",
    padding: "4px 8px",
    display: "none",
    position: "absolute",
    marginLeft: "20px",
    transition: "all 0.3s ease-in-out",
  },
});

const formatTitle = (str) =>
  str
    .split("_")
    .map((s) => s.charAt(0).toUpperCase() + s.slice(1))
    .join(" ");

const RoleDetail = () => {
  const { t } = useTranslation();
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const { id } = useParams();
  const loading = useSelector(selectRolesStatus);
  const role = useSelector(selectRole);

  useEffect(() => {
    if (id && !loading) {
      dispatch(getRoleById(id));
    }
  }, [dispatch, id]);

  const editHandler = () => {
    history.push(PATHS.admin.roleEdit.replace(":id", id));
  };

  const groupedPermissions = role?.Permissions?.reduce((acc, perm) => {
    if (!acc[perm.module]) {
      acc[perm.module] = [];
    }
    acc[perm.module].push(perm);
    return acc;
  }, {});

  return (
    <>
      <Navbar />
      <DarkLayout doublebar loading={loading || !role}>
        <div className={classes._editbox}>
          <Typography className={classes._heading} variant="h4">
            {role?.name}
          </Typography>
          <Box className={classes._buttonbox} component="div">
            <EditIcon onClick={editHandler} className={classes._edit} />
            <Typography component="span" className={clsx(classes._edittext, "edittag")}>
              {t("Edit")}
            </Typography>
          </Box>
        </div>

        <Typography className={classes._infoheading} variant="h5">
          {t("Permissions")}
        </Typography>

        {groupedPermissions &&
          Object.entries(groupedPermissions).map(([module, perms]) => (
            <Card key={module} style={{ marginTop: 24, backgroundColor: "#1E1E1E" }}>
              <CardContent>
                <Typography variant="h6" style={{ color: "#fff", marginBottom: 8 }}>
                  {t(module)}
                </Typography>
                <Box display="flex" flexWrap="wrap">
                  {perms.map((perm) => (
                    <Box key={perm.id} mr={4} mb={2} display="flex" alignItems="center">
                      <CheckIcon style={{ marginRight: 6 }} />
                      <Typography variant="body1" style={{ color: "#fff" }}>
                        {translatePermission(t, module, perm.name)}
                      </Typography>
                    </Box>
                  ))}
                </Box>
              </CardContent>
            </Card>
          ))}
      </DarkLayout>
    </>
  );
};

export default RoleDetail;
